// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3Vvkb","buttons":"RemoveExpirationActionButtons_buttons__KuduO"};